import apiEndpoints from '../../apiEndpoints';
import { fetcher } from '../utils/fetchers/fetcher';

export const requestApp = (
  token: string | null,
  forceHeader?: string
  //TODO: Create return type
): Promise<any> => fetcher<any>(apiEndpoints.routes.app, 'GET', token, forceHeader);
